import React from 'react';
import { useDispatch } from 'react-redux';
import { P3 } from '../../../../../styles/FontStyles';
import { UserImageCircle } from '../../../../../styles/GlobalComponents';
import { color } from '../../../../../styles/GlobalStyles';
import { Icon, IconStructureAlert } from '../../../../../styles/Icons';

import {
  getRootTeamMember,
  openAddNewMemberModal
} from '../../../myTeamBackOffice.actions';
import { StructurePlusButton } from '../StructurePlusButton/StructurePlusButton';
import { LevelTwoWrap } from './LevelTwo.styles';
import { AlertIcon, AlertWrapper } from '../../../MyTeamBackofficeStyled';
import { StructureType } from '../../../myTeamBackOffice.constants';
import { useAppSelector } from '../../../../../app/hooks';

export const LevelTwo = ({ teamMember, parentId, position }) => {
  const dispatch = useDispatch();
  const onPlusClick = () => {
    if (parentId) dispatch(openAddNewMemberModal(parentId, position));
  };

  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <LevelTwoWrap
      disabled={!parentId || (!teamMember && isCanadaRestrictedUser)}>
      {teamMember ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            flexGrow: '1',
            width: '100%'
          }}
          onClick={() => {
            dispatch(getRootTeamMember(teamMember?.id, StructureType.TEAM));
          }}>
          {teamMember?.hasNoPackage ||
          teamMember?.hasUnpaidPackage ||
          teamMember?.isNotQualifiedPartner ||
          teamMember?.isUserNotVerified ? (
            <AlertWrapper>
              <UserImageCircle
                image={teamMember?.profileImageUrl}
                avatar
                avatarSize='20px'
                size='40px'
                margin='0 0 4px 0'
              />
              <AlertIcon color={color.colors.error500}>
                <Icon pointer w='34px' color={color.colors.neutral50}>
                  <IconStructureAlert width={3} height={10} />
                </Icon>
              </AlertIcon>
            </AlertWrapper>
          ) : (
            <UserImageCircle
              image={teamMember?.profileImageUrl}
              avatar
              avatarSize='20px'
              size='40px'
              margin='0 0 4px 0'
            />
          )}

          <P3
            center
            color={color.colors.neutral900}
            style={{ maxWidth: '100%' }}>
            <div className='truncated'>
              <div>{teamMember?.username ?? `#${teamMember?.id}`}</div>
            </div>
          </P3>
        </div>
      ) : (
        <StructurePlusButton onClick={onPlusClick} />
      )}
    </LevelTwoWrap>
  );
};
